import React from "react";
import {
    Modal,
    Image,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    useDisclosure
} from "@chakra-ui/react";

const ImageViewer = ({src, alt,style,className}) => {
    const {isOpen, onOpen, onClose} = useDisclosure();

    return (
        <div style={style} className={className}>
            <Image src={src} alt={alt} cursor="pointer" onClick={onOpen}/>

            {/* Modal for displaying the larger image */}
            <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
                <ModalOverlay/>
                <ModalContent>
                    <ModalCloseButton/>
                    <ModalBody>
                        {/* Large version of the image inside the modal */}
                        <Image src={src} alt={alt} width="100%"/>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </div>
    );
};

export default ImageViewer;